module.exports = __webpack_public_path__ + "media/images/flf-anilina_anilina-5bfd541e6c694f2d807b66e51a6c0ace.jpg";